import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import './sectionModal.css';
import CreateEdit from '../PolicyProduct/RiskFactor/Sections/CreateEdit';

function SectionCreateModal({ handleClose, productId, setNewValue }) {
  return (
    <Dialog fullWidth={true} maxWidth={'lg'} open={true} onClose={handleClose}>
      <DialogContent className="modalContainer">
        <CreateEdit
          setNewValue={setNewValue}
          closeCreateEditForm={handleClose}
          sectionEditDatas={null}
          editStatus={false}
          productId={productId}
        />
      </DialogContent>
    </Dialog>
  );
}

export default SectionCreateModal;
